import { useState, useContext } from "react";
import { Box, Breadcrumbs } from "@material-ui/core";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import CustomTypography from "../atoms/custom_typography";

const BreadcrumbsList = () => {
  const { state } = useContext(AppContext);
  const [pathArray, setPathArray] = useState([]);
  const location = useLocation();
  const breadcrumbsArray = (path) => {
    let res;
    switch (true) {
      case /^\/$/.test(path):
        res = ["ホーム"];
        break;
      case /^\/projects$/.test(path):
        res = ["プロジェクト一覧"];
        break;
      case /^\/project\/issues$/.test(path):
        res = ["チケット一覧"];
        break;
      case /^\/project\/([1-9]\d*|0)\/issues$/.test(path):
        res = [state.current.project.name, "チケット一覧"];
        break;
      case /^\/issue\/([1-9]\d*|0)$/.test(path):
        res = ["チケット詳細"];
        break;
      case /^\/search$/.test(path):
        res = ["検索"];
        break;
      case /^\/tasks$/.test(path):
        res = ["タスク一覧"];
        break;

      default:
        res = ["未設定"];
        break;
    }
    return res;
  };

  useEffect(() => {
    const path = location.pathname;
    setPathArray(breadcrumbsArray(path));
  }, [location]);

  return (
    <Breadcrumbs separator=">" aria-label="breadcrumb">
      {pathArray.map((val, i) => {
        return (
          <Box key={i}>
            <CustomTypography>{val}</CustomTypography>
          </Box>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsList;
